import { AssessmentOverviewQuestionnaireItem } from '../sections/AssessmentOverview/questionnaire'
import { PatientOverviewQuestionnaireItem } from '../sections/PatientOverview/questionnaire'
import { AuthorizationQuestionnaireItem } from '../sections/Authorization/questionnaire'
import { ServicePlanQuestionnaireItem } from '../sections/ServicePlan/questionnaire'
import { VisitSchedulingQuestionnaireItem } from '../sections/VisitScheduling/questionnaire'
import { FinalStepsQuestionnaireItem } from '../sections/FinalSteps/questionnaire'

// Combined questionnaire items from all sections for uncontrolled version
export const ServicePlanAssessmentQuestionnaireItem = {
  ...ServicePlanQuestionnaireItem,
  ...AssessmentOverviewQuestionnaireItem,
  ...PatientOverviewQuestionnaireItem,
  ...AuthorizationQuestionnaireItem,
  ...VisitSchedulingQuestionnaireItem,
  ...FinalStepsQuestionnaireItem
} as const

export type ServicePlanAssessmentQuestionnaireItem =
  (typeof ServicePlanAssessmentQuestionnaireItem)[keyof typeof ServicePlanAssessmentQuestionnaireItem]
